// CompanionshipCare.js
import React from 'react';
import WarmCompanionCareSection from '../components/WarmCompanionCareSection';
import CaregiversEngageSection from '../components/CaregiversEngageSection';
import ThreeStepsSection from '../components/ThreeStepsSection';
import EnrichingLivesSection from '../components/EnrichingLivesSection';
import AllServicesShowcase from '../components/AllServicesShowcase';

const CompanionshipCare = () => {
  const breadcrumbs = [
    { label: 'Home', link: '/' },
    { label: 'Home Care Services', link: null },
    { label: 'Companionship Care', link: null }
  ];

  return (
    <div className="min-h-screen bg-white">
      <section className="bg-cream pt-16 pb-16 md:pt-24 md:pb-20">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <nav className="flex items-center justify-center gap-2 text-sm text-muted mb-6">
            {breadcrumbs.map((crumb, index) => (
              <React.Fragment key={index}>
                {index > 0 && <span className="text-line">/</span>}
                {crumb.link ? (
                  <a href={crumb.link} className="hover:text-primary transition-colors">
                    {crumb.label}
                  </a>
                ) : (
                  <span className="text-ink">{crumb.label}</span>
                )}
              </React.Fragment>
            ))}
          </nav>
          <p className="text-primary text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
            Companionship Care
          </p>
          <h1 className="font-display font-light text-ink leading-[1.1] text-4xl md:text-5xl mb-5">
            Caring Companions in the Comfort of Home
          </h1>
          <p className="text-muted text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
            We enjoy spending time with seniors ageing in place and are happy to provide companionship and any other assistance that is needed.
          </p>
        </div>
      </section>
      <WarmCompanionCareSection />
      <CaregiversEngageSection />
      <ThreeStepsSection />
      <EnrichingLivesSection />
      <AllServicesShowcase />
    </div>
  );
};

export default CompanionshipCare;
